// Client-side chat bookmark + pin id sets. Persists to localStorage so
// state survives reload until a server-side schema lands.

const _BOOKMARKS_KEY = 'chat_bookmarked_msg_ids'
const _PINS_KEY = 'chat_pinned_msg_ids'

const _loadIds = (key) => {
  try {
    const raw = typeof localStorage !== 'undefined' && localStorage.getItem(key)
    const parsed = raw ? JSON.parse(raw) : null
    return Array.isArray(parsed) ? parsed : []
  } catch {
    return []
  }
}

const _saveIds = (key, ids) => {
  try {
    if (typeof localStorage !== 'undefined') localStorage.setItem(key, JSON.stringify(ids))
  } catch {}
}

const _toggle = (ids, msgId) => {
  const i = ids.indexOf(msgId)
  return i === -1 ? [...ids, msgId] : ids.filter(id => id !== msgId)
}

const _toggler = (fieldKey, storageKey) => function (msgId) {
  const root = this.state.root
  if (!root || !msgId) return
  const next = _toggle(root[fieldKey] || _loadIds(storageKey), msgId)
  _saveIds(storageKey, next)
  root.update({ [fieldKey]: next })
}

export const toggleChatBookmark = _toggler('chatBookmarkedMsgIds', _BOOKMARKS_KEY)
export const toggleChatPin = _toggler('chatPinnedMsgIds', _PINS_KEY)
